(function () {
  function openReviewsAndScroll() {
    const details = document.getElementById("reviews");
    if (!details) return;

    details.open = true;

    requestAnimationFrame(() => {
      const anchor = document.getElementById("reviews-anchor") || details;
      anchor.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  }

  document.addEventListener("click", (e) => {
    const trigger = e.target.closest(".jdgm-prev-badge, a[href*='judgeme'], a[href='#judgeme_product_reviews']");
    if (!trigger) return;

    e.preventDefault();
    openReviewsAndScroll();
  });
})();